var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","background-color":"#f9f9f9","overflow-x":"hidden"}},[_c('top-component'),_vm._v(" "),_c('div',{staticClass:"address-wrap"},[_c('h2',[_vm._v("收货地址管理")]),_vm._v(" "),_c('address-component')],1),_vm._v(" "),_c('bottom-component')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f9ca36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ChildPages/addressmanagement.vue
// module id = null
// module chunks = 